// import { onSnapshot, QuerySnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { Carousel } from 'react-bootstrap';
// import { collection, getDocs } from 'firebase/firestore/lite';
import { collection, getDocs } from "firebase/firestore"; 
// import useFirestore from '../hooks/useFireStore';
import db from '../firebase-config';

export default function Home() {
  const [index, setIndex] = useState(0);
  const [sliderData, setSliderData] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };


  useEffect(() => {
    const data = [];

    async function getSliderData() {
      const querySnapshot = await getDocs(collection(db, "slider"));
      querySnapshot.forEach((doc) => {
        const sliderDoc = {...doc.data(), id: doc.id};
        data.push(sliderDoc);
      });
    }
    setSliderData(data);
    setLoading(false); 
    getSliderData()
    console.log(sliderData);
  }, [sliderData])

  if (loading) {
    return <h1>Loading!!</h1>
  }

  
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-md-6'>
        <Carousel activeIndex={index} onSelect={handleSelect}>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://storage.googleapis.com/sgdic-f6ed1.appspot.com/carousel/WhatsApp%20Image%202022-05-29%20at%2010.38.40%20PM.jpeg"
              alt="First slide"
            />
            <Carousel.Caption>
              <h3>Austrailian Stutents visit</h3>
              <p>Students from KRB College, Austrailia</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://storage.googleapis.com/sgdic-f6ed1.appspot.com/carousel/WhatsApp%20Image%202022-05-29%20at%2010.38.45%20PM.jpeg"
              alt="Smt Ganga devi inter college"
            />
            <Carousel.Caption>
              <h3>Austrailian Stutents visit</h3>
              <p>Students from KRB College, Austrailia</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://storage.googleapis.com/sgdic-f6ed1.appspot.com/carousel/WhatsApp%20Image%202022-05-29%20at%2010.38.46%20PM.jpeg"
              alt="Smt Ganga devi inter college"
            />
            <Carousel.Caption>
              <h3>Austrailian Stutents visit</h3>
              <p>Students from KRB College, Austrailia</p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        </div>
        <div className='col-md-6'>
          <img className='img-fluid' src='https://storage.googleapis.com/sgdic-f6ed1.appspot.com/carousel/istockphoto-1273109788-612x612.jpeg' alt='COMING SOON!!'/>
        </div>
      </div>
    </div>
  )
}
